import { render, staticRenderFns } from "./CurriculumStudentViewEEC.vue?vue&type=template&id=cc024774&scoped=true&"
import script from "./CurriculumStudentViewEEC.vue?vue&type=script&lang=ts&"
export * from "./CurriculumStudentViewEEC.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumStudentViewEEC.vue?vue&type=style&index=0&id=cc024774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc024774",
  null
  
)

export default component.exports